import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["key", "select", "secondKey", "submit"];

  connect() {
    this.sync();
  }

  removeWhitespace(event) {
    event.preventDefault();
    const inputs = [this.keyTarget, this.secondKeyTarget];
    inputs.forEach((input) => {
      input.value = input.value.replace(/\s/g, "");
    });
    inputs.forEach((input) => input.dispatchEvent(new Event("input", {bubbles: true})));
    this.keyTarget.focus();
  }

  sync() {
    if (!this.hasKeyTarget || !this.hasSelectTarget || !this.hasSubmitTarget || !this.hasSecondKeyTarget) return;

    const selectedOption = this.selectTarget.selectedOptions?.[0];
    const selectedValue = this.selectTarget.value;
    const usesSiae = selectedOption?.dataset?.siae === "true";
    const hasAtLeastOneKey = this.keyTarget.value.trim() !== "" || this.secondKeyTarget.value.trim() !== "";

    const shouldDisableSubmit = selectedValue === "" || !hasAtLeastOneKey;
    this.submitTarget.disabled = shouldDisableSubmit;
    this.submitTarget.toggleAttribute("disabled", shouldDisableSubmit);

    if (usesSiae) {
      this.secondKeyTarget.removeAttribute("disabled");
      return;
    }

    this.secondKeyTarget.value = "";
    this.secondKeyTarget.setAttribute("disabled", "disabled");
  }
}
